// extracted by mini-css-extract-plugin
module.exports = {"root":"_da04ae"};